import { useLocale } from '~/hooks/useLocale';
import { formatDateToYearMonthDayString } from '~/utils/date';

class ReviewParams {
  constructor(
    private readonly date: Date,
    public readonly periodId: string,
    public readonly timeZone?: string,
  ) {}

  get day(): string {
    return formatDateToYearMonthDayString(this.date);
  }

  toQueryString(): string {
    const params = new URLSearchParams({
      date: this.day,
      periodId: encodeURIComponent(this.periodId ?? ''),
    });
    if (this.timeZone) {
      params.set('tz', this.timeZone);
    }
    return params.toString();
  }

  toRequestBody(): { date: string; periodId: string; tz: string } {
    return {
      date: this.day,
      periodId: this.periodId,
      tz: this.timeZone ?? '',
    };
  }

  toString(): string {
    return `ReviewParams(date: ${this.day}, timeZone: ${this.timeZone}, periodId: ${this.periodId})`;
  }
}

export function useReviewParams({ date, periodId }: { date: Date; periodId: string }): ReviewParams {
  const locale = useLocale();
  return new ReviewParams(date, periodId, locale?.timeZone);
}
